<template>
  <b-modal id="bv-modal-delete-department"
           modal-class="footer-dialog"
           title="Deleting department"
           ref="modal"
  >
    <b-container>
      <b-row>
        <b-col>
          <label>{{$tr('deleteDepartment.message',
              'The department has subunits. Select the department to which to transfer them.')}}</label>
          <b-form-select
              :style="selectedDepartmentInfo ? 'text-indent:' + selectedDepartmentInfo.depth * -8.5 +'px' : ''"
              v-model="selectedDepartmentInfo"
              :options="choiceOfDepartmentsInfo"
          >
          </b-form-select>

        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <div class="w-100 text-center mb-0">
        <FooterNavbar data-test-path="delete-department-dialog">
          <CloseButton @close="cancel"></CloseButton>
          <FooterButton type="Delete" variant="plm-danger-primary" @delete="deleteDepartment"></FooterButton>
        </FooterNavbar>
      </div>
    </template>
  </b-modal>
</template>

<script>
import ValidatedField from "@/validation/ValidatedField";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import Department from "@/server/com/silkplm/model/users/Department";
import Rpc from "@/Rpc";
import Perms from "@/server/Perms";
import PermissionsSet from "@/server/PermissionsSet";
import FooterButton from "@/components/navbar/FooterButton";
import CloseButton from "@/components/navbar/CloseButton";
import tr from "../../utils/Tr";


export default {
  name: "DeleteDepartmentDialog",
  components: {FooterButton, FooterNavbar, CloseButton},
  permission: Perms.ORGANIZATION_SETTINGS,

  async mounted() {
    this.$onInsert(Department, async () => {
      await this.loadChoiceOfDepartmentsList();
    });
    this.$onUpdate(Department, async () => {
      await this.loadChoiceOfDepartmentsList();
    });
    this.$onDelete(Department, async () => {
      await this.loadChoiceOfDepartmentsList();
    });
    this.$onBulkChange(Department, async () => {
      await this.loadChoiceOfDepartmentsList();
    });
  },

  methods: {


    reset() {
      this.result = new ValidatedField();
      this.resolve = null;
    },

    deleteDepartment() {
      if (this.resolve != null) {
        this.resolve(this.selectedDepartmentInfo.department.id);
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },


    cancel() {
      this.$refs.modal.hide();
    },

    async onHide() {
      if (this.resolve != null) {
        this.resolve(null);
        this.resolve = null;
      }
    },

    async loadChoiceOfDepartmentsList() {
      let listOfDepartmentsInfo = await Rpc.organization.Departments.departmentsList();
      this.choiceOfDepartmentsInfo = [];
      if (this.department) {
        for (let i = 0; i < listOfDepartmentsInfo.length; i++) {
          if (listOfDepartmentsInfo[i].name !== this.department.name &&
              listOfDepartmentsInfo[i].department.parentId !== this.department.id) {
            this.choiceOfDepartmentsInfo.push(
                {
                  value: listOfDepartmentsInfo[i],
                  text: "\xa0".repeat(listOfDepartmentsInfo[i].depth * 2) + listOfDepartmentsInfo[i].name
                }
            );
          }
        }
      }
    },

    async loadDepartments(){
      this.department =  await Rpc.organization.Departments.getDepartmentById(this.departmentId);
      this.parentDepartment =  await Rpc.organization.Departments.getDepartmentById(this.department.parentId);
      await this.loadChoiceOfDepartmentsList();
      this.selectDefaultDepartmentAsParent();
    },

    selectDefaultDepartmentAsParent(){
      for (let i = 0; i < this.choiceOfDepartmentsInfo.length; i++) {
        if (this.choiceOfDepartmentsInfo[i].value.name === this.parentDepartment.name) {
          this.selectedDepartmentInfo = this.choiceOfDepartmentsInfo[i].value;
        }
      }
    },
  },


  data: () => ({
    department: null,
    parentDepartment: null,
    resolve: null,
    result: null,
    selectedDepartmentInfo: null,
    choiceOfDepartmentsInfo: [],
    departmentId: null,
    permissions: new PermissionsSet(),
  })
}
</script>


